// extracted by mini-css-extract-plugin
export default {"emptyMessage":"OrgList_emptyMessage__5dO9z","list":"OrgList_list__PrBkc","placeHolderShimmer":"OrgList_placeHolderShimmer__xjk-n"};